import clsx from "clsx";
import { memo, useMemo } from "react";

import type { IIconProps } from "./types";
import classes from "./styles.module.scss";

import {
  fontSizeToPixel,
  iconStyleMapper,
} from "@components/atoms/icons/utils";
import { Icon as IconSet } from "@components/icons";
import { useThemeVariable } from "@/theme";

export const Icon = memo(function Icon(props: IIconProps) {
  const {
    type = "linear",
    name,
    fontSize = "lg",
    color = "inherit",
    className,
    customSize,
    ...rest
  } = props;
  const { color: themeColor } = useThemeVariable(`--theme-${color}`);
  const defaultColor = useMemo(
    () => (color === "inherit" ? "inherit" : themeColor),
    [color, themeColor],
  );

  return (
    <div className={clsx(classes.icon, className)}>
      <IconSet
        name={name}
        color={defaultColor}
        size={customSize || fontSizeToPixel(fontSize)}
        iconStyle={iconStyleMapper(type)}
        {...rest}
      />
    </div>
  );
});
